import React from 'react';
import { Cloner } from '../hooks/Cloner';

const NullReplacement = ({ text: value, replacement, component: child }) => {
  const finalValue = value ? value : replacement;
  return <>{child ? Cloner(child, finalValue) : finalValue}</>;
};

export default NullReplacement;
